const COLORS = Object.freeze({
  blue: "#3FA4E3",
  blureGrey: "#A1B9C7",
  darkGrey: "#222C3B",
  lightGrey: "#F0F0F0",
  middleGrey: "#6A7484",
  green: "#46A354",
  pink: "#E6185E",
  yellow: "#EF971F",
});

export const textColors = Object.freeze({
  pink: "#E6185E",
  grey: "#A1B9C7",
  skyblue: "#3FA4E3",
  orange: "#EF971F",
  darkgreen: "#46A354",
  black: "#000000",
});

export default COLORS;
